import React from 'react'
import MovimentationGraph from './MovimentationGraph'
// import MGraph from './MGraph';
import './movimentations.css'



const Movimentations = props => {
    const data = props.data

    return (
        <div className="movimentation-graph">

            <div style={{ display: 'flex', justifyContent: 'space-between' }} className="movimentation-graph-header">
                <span className="movimentation-graph-title">{props.title || 'Movimentações'}</span>
            </div>

            <div style={{
                width: '100%',
                display: 'flex',
                height: '100%',
                justifyContent: 'center',

            }}>
                <div style={{ width: '50%' }}>
                    <MovimentationGraph data={data} total={total(data)} />
                </div>

                <div style={{ width: '50%', maxWidth: '300px', alignSelf: 'center', marginBottom: '30px' }}>
                    {data.map((d, i) => {
                        return (
                            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginRight: '10px' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ backgroundColor: d.color }} className="movimentation-graph-radio" />
                                    <p style={{ fontWeight: 'bold' }}>{d.label}</p>
                                </div>

                                <div>
                                    <p>{d.value}</p>
                                </div>
                            </div>
                        )
                    })}

                </div>

            </div>


        </div>
    )

}

export default Movimentations


// const graph = d => {
//     // [{ data: [20, 20, 20] }, ]
//     let data = {
//         colors: [],
//         series: [{ data: [] }]
//     }
//     let series = []

//     d.forEach(d => {
//         data.colors.push(d.color)
//         series.push(d.value)
//     });

//     data.series[0].data = series
//     // console.log(data)

//     return data

// }

const total = d => {
    let total = 0
    d.forEach(d => {
        total += d.value
    })
    return total
}